// extracted by mini-css-extract-plugin
module.exports = {"formatted-text":"formatted-text__v3_El","bb-hero-white-font-strapline":"bb-hero-white-font-strapline__Ihc__","heroOverlayAnimation":"heroOverlayAnimation__dIApD"};